'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fbSetFocus = fbSetFocus;
/*@ngInject*/
function fbSetFocus() /*$timeout*/{
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            scope.$watch(attrs.fbSetFocus, function (value) {
                if (value === true) {
                    //$timeout(function() {
                    element[0].focus();
                    scope[attrs.fbSetFocus] = false;
                    //});
                }
            });
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/directives/fb-set-focus.js
// module id = 722
// module chunks = 0